module.exports = __webpack_public_path__ + "static/media/camel_w_2000.2dad1751.jpg";